var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    [
      _c("defs", [
        _vm.assetData
          ? _c("symbol", {
              attrs: { id: _vm.owner },
              domProps: { innerHTML: _vm._s(_vm.assetString) }
            })
          : _vm._e()
      ]),
      _vm._t("default", null, {
        loaded: _vm.loaded,
        asset: _vm.loadedAsset,
        href: "#" + _vm.loadedAssetId
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }